<div class="branding-bar text-xs text-semi">
    <mat-icon class="logo" svgIcon="ge-aerospace" />
    <span class="divider ml-5 mr-5"></span>
    <span>Asset Records - Workflow (Beta)</span>
</div>
